// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"262":"page--common","443":"about"}[chunkId] || chunkId) + "-legacy." + {"95":"8660df94","262":"2c481857","443":"bfbbb2e9","592":"0efb9eb7"}[chunkId] + ".js";
};